import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CButton, CFormLabel } from '@coreui/react-pro'
import { convertHyphenDateToSlashDate } from '../../../../../utils/sharedFunctions'
import InputField from '../../../../../components/common/InputField/InputField'
import MobiScrollCalender from '../../../../../components/common/MobiScrollCalendar/MobiScrollCalendar'
import ButtonGroup from '../../../../../components/common/ButtonGroup/ButtonGroup'
import { dateDbFormat } from '../../../../../utils/dateTimeUtils'
import { toast } from 'react-toastify'
import { calculatePatientIntegration } from '../../../../../components/common/shared/sharedPatientLogic'
import { savePatientDetails } from '../../../../../redux/sidePanel/sidePanelThunk'

export default function PrimaryInfoEditCard({ setEditPatientInfo }) {
  const dispatch = useDispatch()
  const panelEncounter = useSelector((state) => state.sidePanel.panelEncounter)

  const firstName = useSelector((state) => state.sidePanel.panelEncounter?.patient_firstname)
  const middleName = useSelector((state) => state.sidePanel.panelEncounter?.patient_middlename)
  const lastName = useSelector((state) => state.sidePanel.panelEncounter?.patient_lastname)
  const dob = useSelector((state) => state.sidePanel.panelEncounter?.patient_dob)
  const gender = useSelector((state) => state.sidePanel.panelEncounter?.gender)

  const [isDisabled, setIsDisabled] = useState(true)

  const [invalidFirstName, setInvalidFirstName] = useState(firstName?.length < 2)
  const [invalidLastName, setInvalidLastName] = useState(lastName?.length < 2)
  const [invalidDOB, setInvalidDOB] = useState(!dob)

  const [newFirstName, setNewFirstName] = useState(firstName || '')
  const [newMiddleName, setNewMiddleName] = useState(middleName || '')
  const [newLastName, setNewLastName] = useState(lastName || '')
  const [newDOB, setNewDOB] = useState(dob ? dateDbFormat(dob) : '')
  const [newGender, setNewGender] = useState(gender)

  const isPatientActive = panelEncounter?.patient_type === 'active'
  const { isConnected } = calculatePatientIntegration(panelEncounter)

  useEffect(() => {
    if (isPatientActive || isConnected) {
      setIsDisabled(true)
    } else {
      setIsDisabled(false)
    }
  }, [isPatientActive, isConnected])

  return (
    <div id={'PrimaryInfoEditCard'}>
      <div className={'lastname-row'}>
        <InputField
          invalid={invalidLastName}
          errormessage="Please enter a valid name"
          label="Last name *"
          id="last_name"
          value={newLastName}
          onChange={(e) => {
            setNewLastName(e.currentTarget.value)
            if (e.target.value.length < 2) {
              setInvalidLastName(true)
            } else {
              setInvalidLastName(false)
            }
          }}
          disabled={isDisabled}
        />
      </div>
      <div className={'firstname-row'}>
        <InputField
          invalid={invalidFirstName}
          errormessage="Please enter a valid name"
          label="First name *"
          id="first_name"
          value={newFirstName}
          onChange={(e) => {
            setNewFirstName(e.currentTarget.value)
            if (e.target.value.length < 2) {
              setInvalidFirstName(true)
            } else {
              setInvalidFirstName(false)
            }
          }}
          disabled={Boolean(isDisabled)}
        />
      </div>
      <div className={'middlename-row'}>
        <InputField
          label="Middle name"
          id="middle_name"
          value={newMiddleName}
          onChange={(e) => {
            setNewMiddleName(e.currentTarget.value)
          }}
          disabled={Boolean(isDisabled)}
        />
      </div>

      <div className={'dob-row'}>
        <CFormLabel className="label">Date of birth *</CFormLabel>
        <MobiScrollCalender
          label={invalidDOB ? 'Invalid Date Of Birth' : ''}
          placeholder="MM/DD/YYYY"
          value={convertHyphenDateToSlashDate(newDOB)}
          disabled={isDisabled}
          type={'DOB'}
          handleDateChange={(date) => {
            setNewDOB(date)

            // make sure chosen DOB is today or earlier and not overly old
            const newDate = new Date(date)
            const today = new Date()
            const tomorrow = new Date(today)
            const hardAgeCutoff = new Date(today)
            hardAgeCutoff.setFullYear(today.getFullYear() - 150)

            if (newDate > tomorrow || newDate < hardAgeCutoff || date.length < 10) {
              setInvalidDOB(true)
            } else {
              setInvalidDOB(false)
            }
          }}
        ></MobiScrollCalender>
      </div>
      <div className={'gender-row'}>
        <CFormLabel className="label">Gender *</CFormLabel>

        <ButtonGroup
          selected={newGender === 'M' ? 'Male' : newGender === 'F' ? 'Female' : 'Unknown'}
          value={['Male', 'Female', 'Unknown']}
          style={{ border: '1px solid red' }}
          onChange={(genderValue) => {
            setNewGender(genderValue[0])
          }}
          disabled={isDisabled}
        />
      </div>
      <div className={'buttons-row'}>
        <CButton onClick={() => setEditPatientInfo(false)} color={'secondary'}>
          Cancel
        </CButton>
        <CButton
          onClick={async () => {
            console.log({
              newFirstName,
              newMiddleName,
              newLastName,
              newDOB,
              newGender,
            })
            if (invalidFirstName || invalidLastName || invalidDOB) {
              return toast.error('Invalid First/Last name or DOB')
            }
            // is loading?
            await dispatch(
              savePatientDetails({
                firstname: newFirstName,
                middlename: newMiddleName,
                lastname: newLastName,
                DOB: newDOB,
                gender: newGender,
              }),
            )
            setEditPatientInfo(false)
            // TODO and save
          }}
        >
          Save
        </CButton>
      </div>
    </div>
  )
}
